var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultThumbnail = function SvgDefaultThumbnail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00016 18.9173L4.00016 26.6666H20.8925L9.51452 15.2887C8.99383 14.768 8.14962 14.768 7.62891 15.2887L4.00016 18.9173ZM24.6637 26.6666H28.0002V23.2189L24.943 20.1617C24.4223 19.641 23.5781 19.641 23.0574 20.1617L20.6081 22.611L24.6637 26.6666ZM18.7225 20.7254L11.4001 13.4031C9.83805 11.841 7.30542 11.841 5.74332 13.403L4.00016 15.1462V5.33329H28.0002V19.4477L26.8286 18.2761C25.2665 16.714 22.7338 16.714 21.1717 18.2761L18.7225 20.7254ZM4.00016 2.66663C2.5274 2.66663 1.3335 3.86053 1.3335 5.33329V26.6666C1.3335 28.1394 2.5274 29.3333 4.00016 29.3333H28.0002C29.4729 29.3333 30.6668 28.1394 30.6668 26.6666V5.33329C30.6668 3.86053 29.4729 2.66663 28.0002 2.66663H4.00016Z",
    fill: "#D1D0DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6668 12C23.4032 12 24.0002 11.403 24.0002 10.6666C24.0002 9.93025 23.4032 9.33329 22.6668 9.33329C21.9304 9.33329 21.3335 9.93025 21.3335 10.6666C21.3335 11.403 21.9304 12 22.6668 12ZM22.6668 14.6666C24.876 14.6666 26.6668 12.8758 26.6668 10.6666C26.6668 8.45749 24.876 6.66663 22.6668 6.66663C20.4577 6.66663 18.6668 8.45749 18.6668 10.6666C18.6668 12.8758 20.4577 14.6666 22.6668 14.6666Z",
    fill: "#D1D0DA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-thumbnail.7fec8adafaf1fcb4378c0b2327b06f8e.svg";